<template>
	<div id="area_right1">
		<div class="cc-header">教师请假分析
			<div class="view_btn" @click="showTable">请假明细</div>
		</div>
		<div class="main-value" id="tea_leave"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		showTable() {
			this.$emit("showBigEven", "教师请假明细", "teaLeave");
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let teaLeaveRecordChart = echarts.init(
				document.getElementById("tea_leave")
			);
			this.$http.get("/dataView/platform/getTeaLeaveRecord?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = [];
					if (res.data.result.length > 0) {
						for (var i = 0; i < res.data.result.length; i++) {
							var obj = res.data.result[i];
							result.push({ name: obj.leaveType, value: obj.leaveCount });
						}
					} else {
						result.push({ name: '请假', value: 0 });
					}
					var option = {
						tooltip: {
							trigger: 'item'
						},
						legend: {
							show: false,
							orient: 'vertical',
							top: -4,
							left: 25,
							textStyle: {
								fontSize: fontSize(0.12),
								color: '#34deff' // 把颜色这里做成函数就可以了
							},
							itemWidth: 12,
							itemHeight: 6
						},
						grid: {
							top: "10%",
							bottom: "15%",
						},
						series: [{
							name: '人数',
							type: 'pie',
							radius: ['40%', '70%'],
							center: ['50%', '50%'],
							avoidLabelOverlap: false,
							itemStyle: {
								normal: {
									label: {
										formatter: '{b} : {c}',
										textStyle: {
											color: '#34deff',
											fontSize: fontSize(0.12)
										}
									}
								}
							},
							emphasis: {
								label: {
									show: true,
									fontSize: fontSize(0.12),
									color: '#fff'
								}
							},
							data: result
						}]
					};
					teaLeaveRecordChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => teaLeaveRecordChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#area_right1 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall02.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.7rem;
	}

	.main-value {
		height: 82%;
		margin-top: -20px;
	}

	.view_btn {
		position: absolute;
		right: 0.3rem;
		top: 0.6rem;
		display: inline-block;
		cursor: pointer;
		width: 1rem;
		height: 0.35rem;
		line-height: 0.35rem;
		border-radius: 0.2rem;
		background-image: linear-gradient(135deg, #15517c, #323f86);
		color: #35fff9;
		font-size: 0.15rem;
		z-index: 1;
	}
}
</style>
